module.exports = __webpack_public_path__ + "2baa6805a4489671dc3bdb62854ee106.MP3";